import { useEffect, useRef } from 'react';
import { useInView, useAnimation } from 'framer-motion';

interface UseScrollRevealOptions {
  delay?: number;
  duration?: number;
  distance?: number;
  direction?: 'up' | 'down' | 'left' | 'right';
  once?: boolean;
}

export function useScrollReveal(options: UseScrollRevealOptions = {}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: options.once ?? true, margin: '-100px' });
  const controls = useAnimation();

  const {
    delay = 0,
    duration = 0.5,
    distance = 20,
    direction = 'up',
  } = options;

  useEffect(() => {
    if (isInView) {
      controls.start({
        opacity: 1,
        y: direction === 'up' ? 0 : direction === 'down' ? 0 : 0,
        x: direction === 'left' ? 0 : direction === 'right' ? 0 : 0,
        transition: {
          duration,
          delay,
          ease: [0.22, 1, 0.36, 1],
        },
      });
    } else if (!options.once) {
      controls.start({
        opacity: 0,
        y: direction === 'up' ? distance : direction === 'down' ? -distance : 0,
        x: direction === 'left' ? distance : direction === 'right' ? -distance : 0,
      });
    }
  }, [isInView, controls, delay, duration, distance, direction, options.once]);

  const initialY = direction === 'up' ? distance : direction === 'down' ? -distance : 0;
  const initialX = direction === 'left' ? distance : direction === 'right' ? -distance : 0;

  return {
    ref,
    initial: { opacity: 0, y: initialY, x: initialX },
    animate: controls,
  };
}













